export default {
  namespaced: true,
  name: 'SLSTabelaprecoStore',
  state: {
    tabelaprecos: [],
    currentTabelapreco: {
      tabelapreco_id: null,
      tabelapreco_descricao: '',
    },
    loading: false,
    filters: {
      page: 1,
      perPage: 8,
      sortBy: null,
      sortDesc: null,
      tabelapreco_id: null,
      tabelapreco_descricao: null,
    },
  },
  mutations: {
    SET_TABELAPRECOS(state, tabelaprecos) {
      state.tabelaprecos = tabelaprecos;
    },
    SET_CURRENT_TABELAPRECO(state, tabelapreco) {
      state.currentTabelapreco = tabelapreco;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
  },
  getters: {
    tabelaprecos: (state) => state.tabelaprecos,
    currentTabelapreco: (state) => state.currentTabelapreco,
    loading: (state) => state.loading,
    filters: (state) => state.filters,
  },
};
